import { render, staticRenderFns } from "./LikeButton.vue?vue&type=template&id=6d5f6fcc&scoped=true&"
import script from "./LikeButton.vue?vue&type=script&lang=js&"
export * from "./LikeButton.vue?vue&type=script&lang=js&"
import style0 from "./LikeButton.vue?vue&type=style&index=0&id=6d5f6fcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5f6fcc",
  null
  
)

export default component.exports